import React, { useCallback, useEffect, useState } from 'react';
import Box from '@mui/joy/Box';
import Sheet from '@mui/joy/Sheet';
import Typography from '@mui/joy/Typography';
import { Message } from '../../types/message';
import { messagesApi } from '../../api/messages.api';
import MessageBubble from '../chat/MessageBubble';
import { LAYOUT } from '../../theme/layoutTokens';

interface MessageListProps {
  clientReference: string;
}

const MessageList: React.FC<MessageListProps> = ({ clientReference }) => {
  const [messages, setMessages] = useState<Message[]>([]);
  const [loading, setLoading] = useState(true);

  const loadMessages = useCallback(async () => {
    try {
      setLoading(true);
      const data = await messagesApi.getByClientReference(clientReference);
      setMessages(data);
    } catch (error) {
      console.error('Error al cargar mensajes:', error);
    } finally {
      setLoading(false);
    }
  }, [clientReference]);

  useEffect(() => {
    loadMessages();
  }, [loadMessages]);

  return (
    <Sheet variant="outlined" sx={{ overflow: 'hidden', borderRadius: 'md', boxShadow: 'sm' }}>
      <Box sx={{ px: LAYOUT.cardPaddingDense, py: LAYOUT.stackTight, borderBottom: '1px solid', borderColor: 'divider' }}>
        <Typography level="title-md">Mensajes</Typography>
      </Box>
      <Box sx={{ p: LAYOUT.cardPadding, bgcolor: 'background.level1' }}>
        {loading ? (
          <Typography level="body-sm" sx={{ color: 'neutral.500', textAlign: 'center', py: 2 }}>
            Cargando mensajes...
          </Typography>
        ) : messages.length === 0 ? (
          <Typography level="body-sm" sx={{ color: 'neutral.500', textAlign: 'center', py: 2 }}>
            No hay mensajes para mostrar
          </Typography>
        ) : (
          <Box sx={{ display: 'flex', flexDirection: 'column' }}>
            {messages.map((message) => (
              <MessageBubble
                key={message.reference}
                message={message}
                isOwn={Boolean(message.fromMe)}
              />
            ))}
          </Box>
        )}
      </Box>
    </Sheet>
  );
};

export default MessageList;
